export const INSIDE_DRAWER = {
    admin: {
        service_name: "Administración",
        show_drawer: true,
        isOpen: false,
        route: "administracion?servicio=",
    },
    config: {
        service_name: "Configuración",
        show_drawer: true,
        isOpen: false,
        route: "configuracion?servicio=",
    },
    users: {
        service_name: "Usuarios",
        show_drawer: true,
        isOpen: false,
        route: "usuarios",
    },
};

export const Routes = {
    login: {
        route: "/login",
    },
    dashboard: {
        route: "/",
        wordKey: "Home",
        showMenuItem: true,
        needSuperAuth: false,
    },

    usuarios: {
        route: "/usuario",
        wordKey: "Administrativos",
        showMenuItem: true,
        needSuperAuth: false,
    },
    usuarios: {
        route: "/navidad",
        wordKey: "Navidad",
        showMenuItem: true,
        needSuperAuth: false,
    },
    administracion: {
        route: "/administracion",
        wordKey: "Administracion de Usuarios",
        showMenuItem: false,
        needSuperAuth: false,
    },
    dashboardDatosPersonales: {
        route: "/administracion/dashboard-usuarios",
        wordKey: "Datos Personales",
        showMenuItem: false,
        needSuperAuth: false,
    },

    usuariosXServicio: {
        route: "/usuarios-x-servicio",
        wordKey: "Usuarios x servicio",
        showMenuItem: false,
        needSuperAuth: false,
    },
    usuariosGlobales: {
        route: "/usuarios-globales",
        wordKey: "Usuarios Globales",
        showMenuItem: false,
        needSuperAuth: false,
    }
};

export const servicesRoutes = {
    RNCALOR: [
        {
            route: "/beneficiarios",
            wordKey: "Beneficiarios",
            isGroup: false,
        },
        {
            route: "/despachantes",
            wordKey: "Despachantes",
            isGroup: false,
        },

        {
            route: "/usuarios",
            wordKey: "Administrativos",
            isGroup: false,
        },
    ],
    RNES: [
        {
            route: "/rubros",
            wordKey: "Rubros",
            isGroup: false,
        },
        {
            route: "/articulos",
            wordKey: "Articulos",
            isGroup: false,
        },
        {
            route: "/beneficiarios",
            wordKey: "Beneficiarios",
            isGroup: false,
        },
        {
            route: "/despachantes",
            wordKey: "Despachantes",
            isGroup: false,
        },
        {
            route: "/usuarios",
            wordKey: "Administrativos",
            isGroup: false,
        },
        {
            route: "/informes",
            wordKey: "Informes",
            isGroup: false,
        },

    ],
    RNPSOCIAL: [
        {
            route: "/programas",
            wordKey: "Programas",
            isGroup: false,
        },
        {
            route: "/beneficiarios",
            wordKey: "Beneficiarios",
            isGroup: false,
        },
        {
            route: "/comercios",
            wordKey: "Comercios",
            isGroup: false,
        },
        {
            route: "/usuarios",
            wordKey: "Administrativos",
            isGroup: false,
        },
        {
            route: "/informes",
            wordKey: "Informes",
            isGroup: false,
        },

    ],
    RNPSALUD: [
        {
            route: "/zonas",
            wordKey: "Zonas sanitarias",
            isGroup: false,
        },
        {
            route: "/areas",
            wordKey: "Áreas programa",
            isGroup: false,
        },
        {
            route: "/servicios",
            wordKey: "Servicios",
            isGroup: false,
        },
        {
            route: "/departamentos",
            wordKey: "Departamentos",
            isGroup: false,
        },
        {
            route: "/niveles",
            wordKey: "Niveles de complejidad",
            isGroup: false,
        },
        {
            route: "/unidades",
            wordKey: "Unidades",
            isGroup: false,
        },
        {
            route: "/titulos",
            wordKey: "Títulos",
            isGroup: false,
        },
        {
            route: "/hospitales",
            wordKey: "Hospitales",
            isGroup: false,
        },
        {
            route: "/divisiones",
            wordKey: "Divisiones",
            isGroup: false,
        },
        {
            route: "/componentes-secundarios",
            wordKey: "Componentes secundarios",
            isGroup: false,
        },
        {
            route: "/estructuras",
            wordKey: "Estructuras",
            isGroup: false,
        },
    ],
};
